<template>
  <div class="hp-manager-page-list">
    <filter-form :filter="filter" @handleSubmit="handleSubmit">
    </filter-form>
    <standard-table
      ref="datas"
      size="default"
      :bordered="true"
      :columns="columns"
      :indentSize="15"
      :dataSource="datas"
      :pagination="pagination"
      :loading="loading"
      @tableChange="tableChange"
    >
      <!-- <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a @click="handleEdit(1,rowKey.data)">编辑</a>
          <a-divider type="vertical"/>
          <a href="javascript:;" @click="deldata(rowKey.data)">删除</a>
        </span>
      </template>
      <template slot="statusSwitch" slot-scope="rowKey">
        <span>
          <a-switch v-model="rowKey.data.isActive" @change="activeChange(rowKey.data)"/>
        </span>
      </template> -->
    </standard-table>
  </div>
</template>

<script>
import { api } from "@/common";

import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import { watch } from "fs";
import config from "@/config";

export default {
  mixins: [account, dateFormat],
  components: {
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "addressName",
          name: "地址名称"
        },
        {
          type: "select",
          key: "addressType",
          name: "地址类型",
          options: [
            { name: "省", val: 2 },
            { name: "市", val: 3 },
            { name: "区县", val: 4 }
          ]
        },
      ],
      columns: [
        {
          title: "地址名称",
          width: "15%",
          dataIndex: "addressName",
          sorter: true
        },
        {
          title: " 完整地址",
          dataIndex: "fullName",
          width: "35%",
          sorter: true
        },
        {
          title: " 地址类型",
          dataIndex: "addressType",
          width: "10%",
          sorter: true,
           customRender: (text, row, index) => {
            return row.addressTypeDes;
          }
        },
          {
          title: " 地址编码",
          dataIndex: "code",
          width: "15%",
          sorter: true
        }
      ],
      datas: [],
      filterdata: Object.assign(
        { addressName: "", addressType: null, code: "" },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      addVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "500px",
      permissionArray:[]
    };
  },
  async mounted() {
    this.getDatas(this.filterdata);
    this.permissionArray =this.getPermission('Address')
  },
  methods: {
        handleSubmit(p) {
      this.pagination.current=0;  
      this.filterdata.addressName = p.values.addressName;
      this.filterdata.addressType = p.values.addressType;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    refreshCurrent() {this.pagination.current=0;
      this.addVisible = !this.addVisible;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetAddressList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Admins/Address/List.vue